class Ready {
  _isReady = false;
  _data = null;
  readyCallbacks = [];
  exec() {
      while (this.readyCallbacks.length) {
          const callback = this.readyCallbacks.pop();
          callback && callback(this._data);
      }
  }
  ready(callback) {
      this.readyCallbacks.push(callback);
      if (this._isReady) {
          this.exec();
      }
  }
  solved(data) {
      this._data = data;
      this._isReady = true;
      this.exec();
  }
  resetState() {
    this._data = null;
    this._isReady = false;
    this.readyCallbacks = [];
  }
}

export default Ready;
